import { colors, spacing, typography } from "../theme";

export default function EnterpriseHeader({
  title,
  subtitle,
  action,
}) {
  return (
    <div
      style={{
        background: colors.white,
        padding: spacing.lg,
        borderRadius: 16,
        border: `1px solid ${colors.slate200}`,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap",
        gap: spacing.md,
      }}
    >
      <div>
        <div style={typography.title}>{title}</div>

        <div
          style={{
            ...typography.subtitle,
            color: colors.slate500,
            marginTop: 4,
          }}
        >
          {subtitle}
        </div>
      </div>

      {action}
    </div>
  );
}